module.exports = "/_next/static/images/2a33d6a0c925c543a68ed3052432499a-ana_1@3x.png";